import { MiddlewareContext } from ".";
import { useUserStore } from "@/stores/user";
import { useDialog } from "@/stores/dialog";

/**
 * Opens login dialog on routes that requires authentication, redirecting the
 * user to the requested route after a successful login.
 * @param context `MiddlewareContext`
 * @returns `Promise<void>`
 */
export function auth(context: MiddlewareContext) {
  const userStore = useUserStore();

  if (userStore.logged) {
    return context.next();
  }

  useDialog().show("/login", { redirect: context.to.fullPath });

  // Keeps the user on the current page when navigating inside the app,
  // otherwise (direct access, e.g. e-mail links) falls back to home
  if (context.from.matched.length > 0) {
    return context.next(false);
  }

  return context.next("/");
}
